// This list is duplicated in server/Asclepius.Command/EmployerUsers/ConsumerEmailDomainValidator.cs
// If you update this list, update the backend list as well.
const CONSUMER_EMAIL_DOMAINS = new Set([
  // Major consumer providers
  'gmail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.in',
  'yahoo.ca',
  'yahoo.com.au',
  'hotmail.com',
  'hotmail.co.uk',
  'outlook.com',
  'outlook.co.uk',
  'live.com',
  'live.co.uk',
  'msn.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'protonmail.com',
  'proton.me',
  'mail.com',
  'zoho.com',
  'zohomail.com',
  'yandex.com',
  'yandex.ru',
  'gmx.com',
  'gmx.net',
  'gmx.de',
  'fastmail.com',
  'fastmail.fm',
  'hushmail.com',
  'tutanota.com',
  'tutamail.com',
  'tuta.io',
  'rocketmail.com',

  // US ISP email
  'comcast.net',
  'xfinity.com',
  'att.net',
  'verizon.net',
  'sbcglobal.net',
  'cox.net',
  'charter.net',
  'spectrum.net',
  'earthlink.net',
  'optonline.net',
  'frontier.com',
  'windstream.net',
  'suddenlink.net',
  'centurylink.net',
  'bellsouth.net',
  'roadrunner.com',

  // International consumer
  'web.de',
  'freenet.de',
  't-online.de',
  'libero.it',
  'virgilio.it',
  'laposte.net',
  'orange.fr',
  'wanadoo.fr',
  'free.fr',
  'seznam.cz',
  'wp.pl',
  'onet.pl',
  'interia.pl',
  'o2.pl',
  'rediffmail.com',
  'naver.com',
  'daum.net',
  'hanmail.net',
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'sohu.com',
  'yeah.net',
  'foxmail.com',
  'mail.ru',
  'inbox.ru',
  'list.ru',
  'bk.ru',
  'rambler.ru',
  'bigpond.com',
  'optusnet.com.au',

  // Disposable / temporary email services
  'guerrillamail.com',
  'guerrillamail.net',
  'guerrillamail.de',
  'guerrillamail.info',
  'guerrillamailblock.com',
  'grr.la',
  'sharklasers.com',
  'mailinator.com',
  'tempmail.com',
  'throwaway.email',
  'yopmail.com',
  'discard.email',
  'trashmail.com',
  'trashmail.net',
  '10minutemail.com',
  'temp-mail.org',
  'maildrop.cc',
  'fakeinbox.com',
  'mailnesia.com',
  'getnada.com',
  'guerrillamail.org',
])

export const isConsumerEmailDomain = email => {
  if (!email || !email.includes('@')) return false
  const domain = email.split('@')[1]?.toLowerCase()
  return CONSUMER_EMAIL_DOMAINS.has(domain)
}
